<script>
import {mapState} from "vuex"
import ToastHandler from "../invoicing/mixins/ToastHandler.vue"

export default {
    name: "FeesDeleter",

    mixins: [ToastHandler],

    data() {
        return {
            form: {
                year: null,
                month: null,
                accounting_firm_company_id: null,
            },
            monthOptions: [
                {text: 'Tous les mois', value: 0},
                {text: 'Janvier', value: 1},
                {text: 'Février', value: 2},
                {text: 'Mars', value: 3},
                {text: 'Avril', value: 4},
                {text: 'Mai', value: 5},
                {text: 'Juin', value: 6},
                {text: 'Juillet', value: 7},
                {text: 'Août', value: 8},
                {text: 'Septembre', value: 9},
                {text: 'Octobre', value: 10},
                {text: 'Novembre', value: 11},
                {text: 'Décembre', value: 12}
            ]
        }
    },

    computed: {
        ...mapState({
            accountingFirmCompanies: (state) =>
                state.data.options.accountingFirmCompanies,
        }),

        yearOptions() {
            const currentYear = new Date().getFullYear();
            const options = [];

            for (let i = 0; i < 5; i++) {
                const year = currentYear - i;
                options.push({text: year.toString(), value: year});
            }

            return options;
        },

        disableProcess() {
            return this.form.accounting_firm_company_id === null || this.form.month === null || this.form.year === null
        }
    },

    methods: {
        initForm() {
            this.form.year = null
            this.form.month = null
            this.form.accounting_firm_company_id = null
        },

        async process() {
            try {
                this.showRecordingToast()
                const response = await axios.post('feesImportations/delete', this.form)
                this.handleRecordingResponse(response.data.meta)
                this.initForm()
            } catch (e) {
                this.showErrorToast(e)
            }
        }
    }
}
</script>

<template>
    <div>

        <b-row>
            <b-col sm="4">
                <label>Cabinet</label>
                <b-select v-model="form.accounting_firm_company_id" :options="accountingFirmCompanies">
                    <template #first>
                        <b-form-select-option :value="null" disabled>
                            --- Choisir le cabinet ---
                        </b-form-select-option>
                    </template>
                </b-select>
            </b-col>
            <b-col sm="4">
                <label>Mois</label>
                <b-select v-model="form.month" :options="monthOptions">
                    <template #first>
                        <b-form-select-option :value="null" disabled>
                            --- Choisir le mois ---
                        </b-form-select-option>
                    </template>
                </b-select>
            </b-col>
            <b-col sm="4">
                <label>Année</label>
                <b-select v-model="form.year" :options="yearOptions">
                    <template #first>
                        <b-form-select-option :value="null" disabled>
                            --- Choisir l'année ---
                        </b-form-select-option>
                    </template>
                </b-select>
            </b-col>
        </b-row>
        <b-button variant="primary" class="mt-2" @click="process" :disabled="disableProcess">
            Supprimer les enregistrements
        </b-button>
    </div>
</template>

<style scoped>

</style>
